import { checkValidTagsInText } from 'src/app/modules/shared/validators/field-tags.validator';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { customFieldTagRegex } from './../../constants/custom-field-tag.regex';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { create, all } from 'mathjs';
import { SOModuleId } from '../../constants/modules.constant';

@Component({
    selector: 'app-add-fields-expression-dialog',
    templateUrl: './add-fields-expression-dialog.component.html',
    styleUrls: ['./add-fields-expression-dialog.component.scss']
})
export class AddFieldsExpressionDialogComponent implements OnChanges {

    @Input() viewOnly: boolean = false;
    @Input() displayAddExpression: boolean = false;
    @Input() expressionText: string = "";
    @Input() availableFieldsForExpression: SavedSearchNS.IField[] = [];
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() expressionSaved = new EventEmitter<any>();

    //Add Expression
    mathJs = create(all);
    @ViewChild('expressionInput') expressionInput: any;
    expressionOperators = [
        {labelname: '(', value: '('},
        {labelname: ')', value: ')'},
        {labelname: '+', value: '+'},
        {labelname: '-', value: '-'},
        {labelname: '*', value: '*'},
        {labelname: '/', value: '/'},
    ];

    expressionErrorMsg: string = "";
    selectedType: any = null;
    addedFieldTags: string[] = [];


    ngOnChanges(changes: SimpleChanges): void {
        if(changes['availableFieldsForExpression']?.currentValue){
            this.availableFieldsForExpression = changes['availableFieldsForExpression']?.currentValue;
            this.availableFieldsForExpression =  this.availableFieldsForExpression.filter(field => field.objectId !== SOModuleId);
        }

        if(changes['expressionText']?.currentValue){
            this.expressionText = changes['expressionText']?.currentValue;
        }
    }

    //#region ***Add Expression***

    selectTemplateField($event, type: 'field'|'operator' = 'field'){
        const selectedField: any = $event.value;

        const subjectText = this.expressionText;
        const curPos = this.getInputCursorPosition(this.expressionText?.length)?.start;
        const tag = type=='operator' ? `${selectedField.labelname.trim()}` : `[${selectedField.labelname.trim()}]`;
        const firstHalf = `${subjectText.slice(0, curPos)}${tag}`;
        const insertedText = `${firstHalf}${subjectText.slice(curPos)}`;
        this.expressionText = insertedText;



        setTimeout(()=>{
            this.selectedType = null;
            if(this.expressionInput){
                const newCurPos = firstHalf?.length;
                this.expressionInput.nativeElement.setSelectionRange(newCurPos,newCurPos);
            }
            this.updatedAddedTags();
        },100)
    }

    updatedAddedTags(){
        this.addedFieldTags = [];
        const value = this.expressionText;
        if(value){
            const addedTags: string[] = value.match(customFieldTagRegex)||[];

            addedTags.map(labelName=>{
                const exist = this.availableFieldsForExpression.find(field=>field.labelname.trim()==labelName.trim());

                if(exist){
                    if(!this.addedFieldTags.includes(exist.labelname))
                        this.addedFieldTags.push(exist.labelname);
                }
            })
        }
    }

    getInputCursorPosition(textLength: number = 0){
        const cursorPosition = {
            start: textLength,
            end: textLength
        }

        if(this.expressionInput){
            cursorPosition.start = this.expressionInput?.nativeElement?.selectionStart;
            cursorPosition.end = this.expressionInput?.nativeElement?.selectionEnd;
        }

        return cursorPosition;
    }

    validateFormula(expression: any): boolean {

        expression = expression.replace(/\s/g, '').replace(/[-/*]/g, '+');

        if (/(\+\+|--|\]\[|\]\(|\)\(|\)\[)/.test(expression)) {
            return false;
        }

        expression = this.replaceTags(expression);

        try {
          this.mathJs.parse(expression).compile().evaluate();
          return true;
        } catch (error) {
          return false;
        }
    }

    replaceTags(expression: any): string {
        const addedTags: string[] = expression.match(customFieldTagRegex)||[];

        addedTags.map(tag=>{
            expression = expression.replaceAll(`[${tag}]`,' 1 ');
        });

        return expression;
    }

    saveExpression(){
        this.expressionErrorMsg = "";

        const validFormula = this.validateFormula(this.expressionText);
        const validTags = checkValidTagsInText(this.availableFieldsForExpression,this.expressionText, 'labelname').valid;

        if(!validFormula || !validTags){
            this.expressionErrorMsg = !validTags ? "Expression contains invalid tags." : "Expression not valid, please check and correct.";
            return;
        }


        this.updatedAddedTags();

        const savedData = {
            expressionText: this.expressionText,
            addedFieldTags: this.addedFieldTags
        }

        this.expressionSaved.emit(savedData);
        this.expressionDialogClose();
    }

    expressionDialogClose(){
        this.displayAddExpression = false;
        this.dialogClosed.emit(true);
    }

    //#endregion ***Add Expression***

}
